import React, { createContext, useContext, useState, useEffect } from "react";

const DateRangeContext = createContext();

export function DateRangeProvider({ children }) {
    const [windowDays, setWindowDays] = useState(() => {
        return sessionStorage.getItem("windowDays") || "30";
    });

    // Persist to sessionStorage whenever windowDays changes
    useEffect(() => {
        sessionStorage.setItem("windowDays", windowDays);
    }, [windowDays]);

    return (
        <DateRangeContext.Provider value={{ windowDays, setWindowDays }}>
            {children}
        </DateRangeContext.Provider>
    );
}

export function useDateRange() {
    return useContext(DateRangeContext);
}